import React from 'react';
import { useVatCausesRender } from 'src/components/AppShell/VatProvider';

type Props = Record<string, unknown>;

export const VatInfo: React.FC<Props> = () => {
    const { vat } = useVatCausesRender();

    return <>{vat ? 'inc' : 'ex'}. VAT</>;
};
